import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {AlertConfigsData} from '../models/alert-config.model';

@Injectable()
export class AlertsConfigAdapter implements IAdapter<AlertConfigsData> {
  adaptToModel(resp: any): AlertConfigsData {
    const highPriority = 1,
      mediumPriority = 2,
      lowPriority = 3;
    const alertConfigData: AlertConfigsData = {...resp};
    alertConfigData.configValue.alertConfigs.forEach(alertConfig => {
      alertConfig.yellowAlertCount = 0;
      alertConfig.orangeAlertCount = 0;
      alertConfig.redAlertCount = 0;

      alertConfig.alerts.forEach(alert => {
        if (alert.priority === highPriority) {
          alertConfig.redAlertCount++;
        }
        if (alert.priority === mediumPriority) {
          alertConfig.orangeAlertCount++;
        }
        if (alert.priority === lowPriority) {
          alertConfig.yellowAlertCount++;
        }
      });
    });

    return alertConfigData;
  }
  adaptFromModel(data: AlertConfigsData): any {
    const dataToSend = Object.assign({}, data);
    dataToSend.configValue.alertConfigs.forEach(config => {
      delete config.orangeAlertCount;
      delete config.yellowAlertCount;
      delete config.redAlertCount;
    });
    return dataToSend;
  }
}
